var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLPfacebookicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.955,
    height: 13.955,
    viewBox: "0 0 13.955 13.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "facebook_2_",
    "data-name": "facebook (2)",
    d: "M12.077,0H1.883A1.881,1.881,0,0,0,0,1.88V12.075a1.88,1.88,0,0,0,1.881,1.88H6.91l.009-4.987h-1.3a.306.306,0,0,1-.306-.3L5.311,7.056a.306.306,0,0,1,.306-.307H6.91V5.2A2.538,2.538,0,0,1,9.619,2.412h1.319a.306.306,0,0,1,.306.306V4.073a.306.306,0,0,1-.306.306h-.81c-.874,0-1.044.416-1.044,1.025V6.75h1.921a.306.306,0,0,1,.3.342L11.12,8.7a.306.306,0,0,1-.3.27H9.094l-.009,4.987h2.992a1.88,1.88,0,0,0,1.88-1.88V1.88A1.881,1.881,0,0,0,12.077,0Z",
    transform: "translate(-0.002)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLPfacebookicon);
export default __webpack_public_path__ + "static/media/LPfacebookicon.3e029337aaa0339c072eb00b6ca3e357.svg";
export { ForwardRef as ReactComponent };